export type ButtonEnumInputType<T extends string> = T | null | `${T}`;

export const buttonEnumInputTransformer = <T extends string>(
	value: ButtonEnumInputType<T>,
	allValues: T[],
	defValue: T
): T => {
	if (value === null) {
		return defValue;
	}

	const valueAsEnum = value as T;
	const valid = allValues.includes(valueAsEnum);
	return valid ? valueAsEnum : defValue;
};
